module.exports = __webpack_public_path__ + "static/media/review_2.bd516b47.png";